// Cleaned-up and Vue 3 optimized version of your Vuex store module
import axios from 'axios'
import { handleError } from '@/helpers/HandleError';
import * as general_state from '../store'
import router from '../../router/router'

const state = {
	evalvation_program_detail: {},
	evalvation_department_detail: {},
	evalvation_questionnaire_detail: {},
	evalvation_internal_questionnaire_detail: {},
	active_q_page_id: '',
	questionnaire_data: {},
	questionnaire_multiple_data: {},
	table_details: {},
	question_image_types: {},
	faculties_internal_permission: [19]
}

const getters = {
	evalvation_program_detail: state => state.evalvation_program_detail,
	faculties_internal_permission: state => state.faculties_internal_permission,
	evalvation_department_detail: state => state.evalvation_department_detail,
	evalvation_questionnaire_detail: state => state.evalvation_questionnaire_detail,
	evalvation_internal_questionnaire_detail: state => state.evalvation_internal_questionnaire_detail,
	active_q_page_id: state => state.active_q_page_id,
	questionnaire_data: state => state.questionnaire_data,
	questionnaire_multiple_data: state => state.questionnaire_multiple_data,
	table_details: state => state.table_details,
	question_image_types: state => state.question_image_types
}

const mutations = {
	getProgramDetail(state, payload) {
		state.evalvation_program_detail = payload
	},
	getDepartmentDetail(state, payload) {
		state.evalvation_department_detail = payload
	},
	getQuestionnaireDetails(state, payload) {
		state.evalvation_questionnaire_detail = payload
		const pages = payload.pages || {}
		const firstPage = Object.values(pages).find(p => p.order_number === 1)
		state.active_q_page_id = firstPage ? firstPage.id : ''
	},
	getInternalQuestionnaireDetails(state, payload) {
		state.evalvation_internal_questionnaire_detail = payload
	},
	refreshQuestionnaireDetails(state, payload) {
		const isInternal = !payload.pages[state.active_q_page_id]
		if (isInternal) {
			state.evalvation_internal_questionnaire_detail = payload
		} else {
			state.evalvation_questionnaire_detail = payload
		}
	},
	incrementAttachmentCount(state, question_id) {
		if (!state.questionnaire_data[question_id]) {
			state.questionnaire_data[question_id] = { answer: '', attachment_count: 1 };
		} else {
			const count = state.questionnaire_data[question_id].attachment_count || 0;
			state.questionnaire_data[question_id].attachment_count = count + 1;
		}
	},
	// Edit page in questionnaire
	editQuestionnairePage: (state, { name, description }) => {
		const id = state.active_q_page_id;

		const page =
			state.evalvation_questionnaire_detail?.pages?.[id] ??
			state.evalvation_internal_questionnaire_detail?.pages?.[id];

		if (!page) return;

		page.name = name;
		page.description = description;
	},

	addQuestionnairePage(state, payload) {
		const data = payload.data
		if (payload.internal) {
			state.evalvation_internal_questionnaire_detail = data
		} else {
			state.evalvation_questionnaire_detail = data
		}
		const pages = data.pages || {}
		const lastPageId = Object.keys(pages).pop()
		state.active_q_page_id = lastPageId
	},
	deleteQuestionnairePage(state) {
		const isInternal = !state.evalvation_questionnaire_detail.pages[state.active_q_page_id]
		const target = isInternal ? state.evalvation_internal_questionnaire_detail : state.evalvation_questionnaire_detail
		delete target.pages[state.active_q_page_id]
		const firstPage = Object.values(target.pages).find(p => p.order_number === 1)
		state.active_q_page_id = firstPage ? firstPage.id : ''
	},
	changeActivePageQ(state, payload) {
		state.active_q_page_id = payload
	},
	// Add question in page
	addQuestionnaireQuestion: (state, payload) => {
		if (state.evalvation_questionnaire_detail.pages?.[state.active_q_page_id]) {
			state.evalvation_questionnaire_detail = structuredClone(payload);
		} else {
			state.evalvation_internal_questionnaire_detail = structuredClone(payload);
		}
	},

	// Edit question in page
	editQuestionnaireQuestion: (state, payload) => {
		let page = state.evalvation_questionnaire_detail.pages?.[state.active_q_page_id]
			?? state.evalvation_internal_questionnaire_detail.pages?.[state.active_q_page_id];

		if (!page) return;

		const question = page.questions[payload.order_number];
		if (!question) return;

		question.title = payload.title;
		question.description = payload.description;
		question.break = payload.break ? '1' : '0';
		question.stopnja = payload.stopnja;
		question.vrsta = payload.vrsta;
		question.lastnost = payload.lastnost;
		question.sample_evalvation = payload.sample_evalvation;
	},

	// Delete question in page
	deleteQuestionnaireQuestion: (state, payload) => {
		let page = state.evalvation_questionnaire_detail.pages?.[state.active_q_page_id]
			?? state.evalvation_internal_questionnaire_detail.pages?.[state.active_q_page_id];

		if (!page || !page.questions) return;

		const questions = page.questions;
		const q_keys = Object.keys(questions);
		const q_num = q_keys.length ? Math.max(...q_keys.map(Number)) : 0;

		for (let i = payload.order_number; i < q_num; i++) {
			delete questions[i];
			questions[i] = questions[+i + 1];
			if (questions[i]) questions[i].order_number = i;
		}

		delete questions[q_num];

		// Trigger reactivity in Vue 3 by shallow copying the parent object
		if (state.evalvation_questionnaire_detail.pages?.[state.active_q_page_id]) {
			state.evalvation_questionnaire_detail = structuredClone(state.evalvation_questionnaire_detail);
		} else {
			state.evalvation_internal_questionnaire_detail = structuredClone(state.evalvation_internal_questionnaire_detail);
		}
	},

	getQuestionnaireData(state, payload) {
		state.questionnaire_data = payload
	},
	getMultipleQuestionData(state, { question_id, data }) {
		state.questionnaire_multiple_data = {
			...state.questionnaire_multiple_data,
			[question_id]: data
		}
	},
	setProgramFinishedStatus(state, payload) {
		state.evalvation_program_detail = {
			...state.evalvation_program_detail,
			finished: payload
		};
	},
	setDepartmentFinishedStatus(state, payload) {
		state.evalvation_program_detail = {
			...state.evalvation_department_detail,
			finished: payload
		};
	},
	saveQuestionData(state, payload) {
		const qid = payload.question_id
		state.questionnaire_data = {
			...state.questionnaire_data,
			[qid]: {
				...state.questionnaire_data[qid],
				answer: payload.value,
				attachment_count: state.questionnaire_data[qid]?.attachment_count || 0
			}
		}
	},
	saveExtendedProgram(state, payload) {
		state.evalvation_program_detail = {
			...state.evalvation_program_detail,
			extended: payload.extended
		}
	},
	saveQuestionMultipleData(state, payload) {
		const { question_id, program_id, value } = payload
		state.questionnaire_multiple_data = {
			...state.questionnaire_multiple_data,
			[question_id]: {
				...state.questionnaire_multiple_data[question_id],
				[program_id]: value
			}
		}
	},
	saveBreakData(state, payload) {
		const { question_id, break_id, value } = payload
		const target = state.questionnaire_data[question_id] || {}
		const breaks = { ...target.breaks, [break_id]: value }
		state.questionnaire_data = {
			...state.questionnaire_data,
			[question_id]: {
				...target,
				breaks
			}
		}
	},
	updateQuestionnaireIntro(state, payload) {
		state.evalvation_questionnaire_detail = {
			...state.evalvation_questionnaire_detail,
			intro: payload
		}
	},
	getTableDetails(state, payload) {
		state.table_details = payload
	},
	editQuestionFixTableColumn(state, payload) {
		const table = `table${payload.table_number}`
		const data = state.table_details?.[table]?.structure?.data || {}
		data[`column${payload.column_number}_title`] = payload.title
		data[`column${payload.column_number}_description`] = payload.description
	},
	editQuestionTableColumn: (state, payload) => {
		const page = state.evalvation_questionnaire_detail.pages?.[state.active_q_page_id]
			?? state.evalvation_internal_questionnaire_detail.pages?.[state.active_q_page_id];

		if (!page) return;

		const column = page.questions?.[payload.q_order_num]?.columns?.[payload.c_order_num];
		if (!column) return;

		column.name = payload.name;
		column.description = payload.description;
	},
	removeQuestionTableColumn: (state, payload) => {
		const detail = state.evalvation_questionnaire_detail.pages?.[state.active_q_page_id]
			? 'evalvation_questionnaire_detail'
			: 'evalvation_internal_questionnaire_detail';

		const columns = state[detail].pages?.[state.active_q_page_id]?.questions?.[payload.q_order_num]?.columns;
		if (!columns) return;

		delete columns[payload.c_order_num];

		// Trigger reactivity
		state[detail] = structuredClone(state[detail]);
	},
	removeQuestionTableRow: (state, payload) => {
		const rows = state.questionnaire_data?.[payload.question_id]?.table_rows;
		if (!rows) return;

		delete rows[payload.row_id];

		if (Object.keys(rows).length === 0) {
			delete state.questionnaire_data[payload.question_id].table_rows;
		}

		state.questionnaire_data = structuredClone(state.questionnaire_data);
	},
	addQuestionTableRow: (state, payload) => {
		const isStandard = !!state.evalvation_questionnaire_detail.pages?.[state.active_q_page_id];
		const questions = isStandard
			? state.evalvation_questionnaire_detail.pages[state.active_q_page_id]?.questions
			: state.evalvation_internal_questionnaire_detail.pages[state.active_q_page_id]?.questions;

		const columns = questions?.[payload.q_order_num]?.columns;
		if (!columns) return;

		const lastYearRows = state.questionnaire_data?.[payload.question_id]?.table_rows_last_year || null;
		const value = payload.value || '';
		const clearTable = payload.clear_table || false;

		// Ensure base structure exists
		if (!state.questionnaire_data[payload.question_id] || clearTable) {
			state.questionnaire_data[payload.question_id] = { table_rows: {} };
		}

		const table = state.questionnaire_data[payload.question_id];

		// Ensure table_rows exists
		if (!table.table_rows) {
			table.table_rows = {};
		}

		// Ensure row exists
		if (!table.table_rows[payload.row_id]) {
			table.table_rows[payload.row_id] = { table_columns: {} };
		}

		// Write column values
		for (let column of Object.values(columns)) {
			table.table_rows[payload.row_id].table_columns[column.id] = value;
		}

		// Copy last year if exists
		if (lastYearRows) {
			table.table_rows_last_year = lastYearRows;
		}

		// Trigger reactivity
		state.questionnaire_data = structuredClone(state.questionnaire_data);
	},
	getQuestionImageTypes(state, payload) {
		state.question_image_types = payload
	},
	decrementAttachmentCount(state, question_id) {
		if (
			state.questionnaire_data[question_id] &&
			state.questionnaire_data[question_id].attachment_count > 0
		) {
			state.questionnaire_data[question_id].attachment_count--;
		}
	}
}

const actions = {
	// Change active page
	changeActivePageQ: ({ commit, dispatch }, page_id) => {
		if (page_id == 'RU') {
			dispatch('getTableDetails');
		}
		commit('changeActivePageQ', page_id);
	},

	// Prepare table detail
	getTableDetails: ({ commit }) => {
		commit('showModalWorking');

		let programs = router.currentRoute.value?.params?.programs ? router.currentRoute.value.params.programs.toString().split(",") : "";
		axios.get('?module=evalvation_table&action=get_data&questionaire_id=' + state.evalvation_questionnaire_detail.id + '&program_id=' + programs[0])
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('getTableDetails', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Insert table row
	insertTableRow: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let table_number = payload;
		let programs = router.currentRoute.value?.params?.programs ? router.currentRoute.value.params.programs.toString().split(",") : "";

		payload = { additional_programs: Array.from(programs).slice(1) };
		axios.post('?module=evalvation_table&action=insert_row&questionaire_id=' + state.evalvation_questionnaire_detail.id + '&program_id=' + programs[0] + '&table_number=' + table_number, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						dispatch('getTableDetails');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete table row
	deleteTableRow: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let programs = router.currentRoute.value?.params?.programs ? router.currentRoute.value.params.programs.toString().split(",") : "";
		axios.post('?module=evalvation_table&action=delete_row&row_id=' + payload.row_id + '&program_id=' + programs[0] + '&table_number=' + payload.table_number, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						dispatch('getTableDetails');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Update table cell
	saveTableCell: ({ commit }, payload) => {
		//commit('showModalWorking');

		let programs = router.currentRoute.value?.params?.programs ? router.currentRoute.value.params.programs.toString().split(",") : "";
		axios.post('?module=evalvation_table&action=save_cell&questionaire_id=' + state.evalvation_questionnaire_detail.id + '&row_id=' + payload.row_id +
			'&program_id=' + programs[0] + '&table_number=' + payload.table + '&column_number=' + payload.column, payload)
			.then(
				res => {
					if (res.data.error) {
						//commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						//commit('saveTableCell', payload);
						//commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Prepare program detail
	getProgramDetail: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_program&action=get_details&program_id=' + payload.program_id, payload)
			.then(
				res => {
					if (res.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('getProgramDetail', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Prepare program detail
	getDepartmentDetail: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.get('?module=evalvation_oddelek&action=get_details&oddelek_id=' + payload)
			.then(
				res => {
					if (res.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('getDepartmentDetail', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Prepare questionnaire detail
	getQuestionnaireDetails: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let params = '';
		if (payload.id)
			params = 'questionaire_id=' + payload.id
		else if (payload.type)
			params = 'type=' + payload.type + '&year=' + general_state.state.year

		axios.get('?module=evalvation_questionaire&action=get_questionaire_details&' + params)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						//if internal questionnaire details
						if ((typeof payload.type === 'string' || payload.type instanceof String) &&
							(payload.type.includes('3_') || payload.type.includes('5_'))) {
							commit('getInternalQuestionnaireDetails', res.data);
							commit('hideModalWorking');
						}
						//normal questionnaire and departmnents
						else {
							commit('getQuestionnaireDetails', res.data);
							commit('hideModalWorking');
						}

						//get internal questionnaire details
						if (payload.type == 1 || payload.type == 4) {
							let program_id = router.currentRoute.value?.params?.programs ? router.currentRoute.value.params.programs.toString().split(",")[0] : "";
							let faculty_id = general_state.state.faculty.id;
							let pre_id = payload.type == 1 ? '3_' : '5_';
							if (program_id) {
								faculty_id = state.evalvation_program_detail.faculty_id;
							}

							dispatch('getQuestionnaireDetails', { type: pre_id + faculty_id });
						}

						//if there is multple programs fill out, get special questions
						if (payload.type == 1 && router.currentRoute.value?.params?.programs && router.currentRoute.value.params.programs.toString().split(",").length > 1) {
							let q_detail = state.evalvation_questionnaire_detail;
							//get first question id of first page
							let question_id = q_detail.pages[Object.keys(q_detail.pages)[0]].questions[Object.keys(q_detail.pages[Object.keys(q_detail.pages)[0]].questions)[0]].id;

							dispatch('getMultipleQuestionData', { question_id: question_id, program_ids: router.currentRoute.value.params.programs.toString().split(",") });
						}
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add page in questionnaire
	addQuestionnairePage: ({ commit }, payload) => {
		commit('showModalWorking');

		let questionnaire_id = payload.questionnaire_id ? payload.questionnaire_id : state.evalvation_questionnaire_detail.id;
		axios.post('?module=evalvation_questionaire&action=add_page&questionaire_id=' + questionnaire_id, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						let pass = { data: res.data };
						//if internal questionnaire
						if (payload.questionnaire_id)
							pass.internal = true;
						commit('addQuestionnairePage', pass);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit page in questionnaire
	editQuestionnairePage: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_questionaire&action=edit_page&page_id=' + state.active_q_page_id, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('editQuestionnairePage', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete page in questionnaire
	deleteQuestionnairePage: ({ commit }) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_questionaire&action=delete_page&page_id=' + state.active_q_page_id)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('deleteQuestionnairePage');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add question in questionnaire
	addQuestionnaireQuestion: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_questionaire&action=add_question&page_id=' + state.active_q_page_id, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('addQuestionnaireQuestion', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete question in questionnaire
	deleteQuestionnaireQuestion: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_questionaire&action=delete_question&question_id=' + payload.id)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('deleteQuestionnaireQuestion', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit question in questionnaire
	editQuestionnaireQuestion: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_questionaire&action=edit_question&question_id=' + payload.id, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						//commit('editQuestionnaireQuestion', payload);
						commit('refreshQuestionnaireDetails', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get questionnaire answers for department
	getDepartmentQuestionnaireData: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.get('?module=evalvation_data&action=get_questionaire_data_oddelek&oddelek_id=' + payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('getQuestionnaireData', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get questionnaire answers for program
	getQuestionnaireData: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.get('?module=evalvation_data&action=get_questionaire_data&program_id=' + payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('getQuestionnaireData', res.data);
						commit('hideModalWorking');

					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get data for specific question
	getMultipleQuestionData: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_data&action=get_question_data&question_id=' + payload.question_id, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('getMultipleQuestionData', { question_id: payload.question_id, data: res.data.programs });
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Save answer
	saveQuestionData: ({ commit }, payload) => {
		//commit('showModalWorking');

		//save in vue object first, to avoid "jumping" because of waiting on promise
		if (payload.multiple)
			commit('saveQuestionMultipleData', payload);
		else
			commit('saveQuestionData', payload);

		axios.post('?module=evalvation_data&action=save_question_data&question_id=' + payload.question_id + '&program_id=' + payload.program_id, payload)
			.then(
				res => {
					if (res.data.error) {
						//commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						//commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Save department answer
	saveDepartmentQuestionData: ({ commit }, payload) => {
		//commit('showModalWorking');

		//save in vue object first, to avoid "jumping" because of waiting on promise
		commit('saveQuestionData', payload);

		axios.post('?module=evalvation_data&action=save_oddelek_data&question_id=' + payload.question_id + '&oddelek_id=' + payload.department_id, payload)
			.then(
				res => {
					if (res.data.error) {
						//commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						//commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Save extended program
	saveExtendedProgram: ({ commit }, payload) => {
		//save in vue object first, to avoid "jumping" because of waiting on promise
		commit('saveExtendedProgram', payload);

		axios.post('?module=evalvation_program&action=save_program_extended', payload)
			.then(
				res => {
					if (res.data.error) {
						//commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	//save break answer
	saveBreakData: ({ commit }, payload) => {
		//commit('showModalWorking');
		axios.post('?module=evalvation_data&action=save_break_data&question_id=' + payload.question_id + '&break_id=' + payload.break_id, payload)
			.then(
				res => {
					if (res.data.error) {
						//commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('saveBreakData', payload);
						//commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Copy questionnaire
	copyQuestionnaire: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.get('?module=evalvation_questionaire&action=copy_questionaire&year_from=' + payload.year_from + '&year_to=' + general_state.state.year + '&type_from=' + payload.type)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						if (res.data.error == 'No questionaire id')
							commit('showModal', { component: 'ModalError', data: 'Obrazec v tem letu ne obstaja' })
						else
							commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('getQuestionnaireDetails', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Create new questionnaire
	createNewQuestionnaire: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.get('?module=evalvation_questionaire&action=create_new_questionaire&year=' + general_state.state.year + '&type=' + payload.type)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						//if internal questionnaire details
						if ((typeof payload.type === 'string' || payload.type instanceof String) && (payload.type.includes('3_') || payload.type.includes('5_'))) {
							commit('getInternalQuestionnaireDetails', res.data);
							commit('hideModalWorking');
							if (payload.create_page) {
								commit('showModal', { component: 'evalvation/CreateQuestionnairePage', data: { questionnaire_id: res.data.id } });
							}
						}
						else {
							commit('getQuestionnaireDetails', res.data);
							commit('hideModalWorking');
						}
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Update questionnaire intro
	updateQuestionnaireIntro: ({ commit }, payload) => {
		axios.post('?module=evalvation_questionaire&action=save_questionaire_intro&questionaire_id=' + state.evalvation_questionnaire_detail.id, payload)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('updateQuestionnaireIntro', payload.value);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Export questionnaire
	exportQuestionnaire: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let program = payload.program_id ? '&program_id=' + payload.program_id : '';
		let department = payload.department_id ? '&oddelek_id=' + payload.department_id : '';
		let export_mode = payload.export_mode ? '&export_mode=' + payload.export_mode : '';

		axios.post('?module=export&action=get_evalvation_export&questionaire_id=' + payload.questionnaire_id + '&format=' + payload.format +
			'&faculty=' + general_state.state.faculty.id + program + department + export_mode, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
						commit('showModal', {
							component: 'ModalWarning',
							data: { title: "Posodobitev kazala vsebine", description: '<p>Ko prvič odprete dokument v Microsoft Wordu, posodobite kazalo vsebine z naslednjimi koraki:</p><ol><li>Desni klik na kazalo vsebine.</li><li>Izberite <strong>"Posodobi polje"</strong>.</li><li>Izberite <strong>"Posodobi celotno kazalo"</strong>.</li></ol><p>To bo zagotovilo, da bodo številke strani v kazalu pravilno prikazane.</p>' }
						})
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Export questionnaire level for all programs
	exportQuestionnaireLevelAllPrograms: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.get('?module=export&action=get_evalvation_export_page_all_programs&questionaire_id=' + payload.questionnaire_id + '&format=' + payload.format +
			'&faculty=' + payload.faculty_id + '&level_id=' + payload.level_id + '&year=' + payload.year)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add column in table question
	addQuestionTableColumn: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_questionaire&action=add_column&question_id=' + payload.question_id, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('refreshQuestionnaireDetails', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit column in table question
	editQuestionTableColumn: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_questionaire&action=edit_column&column_id=' + payload.column_id, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('editQuestionTableColumn', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Remove column in table question
	removeQuestionTableColumn: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_questionaire&action=delete_column&column_id=' + payload.column_id)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('removeQuestionTableColumn', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add department or program question table row
	addQuestionTableRow: ({ commit }, payload) => {
		//commit('showModalWorking');
		let value = payload.value ? payload.value : '';
		let clear_table = payload.clear_table ? payload.clear_table : false;
		let programs = router.currentRoute.value?.params?.programs ? router.currentRoute.value.params.programs.toString().split(",") : "";

		let call = (payload.questionnaire_type == 1 || payload.questionnaire_type == 4) ?
			'?module=evalvation_data&action=insert_program_row&question_id=' + payload.question_id + '&program_id=' + programs[0] :
			'?module=evalvation_data&action=insert_oddelek_row&question_id=' + payload.question_id + '&oddelek_id=' + payload.dep_or_prog_id
		axios.post(call, { additional_programs: payload.additional_programs, value: value, clear_table: clear_table })
			.then(
				res => {
					if (res.data.error) {
						//commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						payload.row_id = res.data.row_id;
						commit('addQuestionTableRow', payload);
						//commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Remove department table row
	deleteQuestionTableRow: ({ commit }, payload) => {
		//commit('showModalWorking');
		let call = (payload.questionnaire_type == 1 || payload.questionnaire_type == 4) ?
			'?module=evalvation_data&action=delete_program_row&row_id=' + payload.row_id :
			'?module=evalvation_data&action=delete_oddelek_row&row_id=' + payload.row_id;
		axios.post(call, { additional_programs: payload.additional_programs })
			.then(
				res => {
					if (res.data.error) {
						//commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('removeQuestionTableRow', payload);
						//commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Update table cell
	saveQuestionTableCell: ({ commit }, payload) => {
		//commit('showModalWorking');

		let call = (payload.questionnaire_type == 1 || payload.questionnaire_type == 4) ?
			'?module=evalvation_data&action=save_program_cell_data&row_id=' + payload.row_id + '&column_id=' + payload.column_id :
			'?module=evalvation_data&action=save_oddelek_cell_data&row_id=' + payload.row_id + '&column_id=' + payload.column_id;
		axios.post(call, payload)
			.then(
				res => {
					if (res.data.error) {
						//commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						//commit('saveTableCell', payload);
						//commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit column in fixed table
	editQuestionFixTableColumn: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=evalvation_table&action=edit_table_column_title&questionaire_id=' + state.evalvation_questionnaire_detail.id +
			'&table_number=' + payload.table_number + '&column_number=' + payload.column_number, payload)
			.then(
				res => {
					if (res.data.error) {
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('editQuestionFixTableColumn', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get list of image types for questionnaire
	getQuestionImageTypes: ({ commit }) => {
		axios.get('?module=evalvation_questionaire&action=get_question_image_types')
			.then(
				res => {
					if (res.data.error) {
						commit('showModal', { component: 'ModalError', data: res.data.error })
					}
					else {
						commit('getQuestionImageTypes', res.data.image_types);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

};

export default {
	state,
	getters,
	actions,
	mutations
}